import styled from 'styled-components';

import fonts from '../../theme/fonts';
import media from '../../theme/media';

const getLabelColor = (props) => {
    if (props.isReadOnly) {
        return props.theme.grey_40_lc;
    } else if (!props.isFocused && !props.isError) {
        return props.theme.grey_72_lc;
    } else if (props.isFocused && !props.isError) {
        return props.theme.purple_100;
    } else if (props.isError) {
        return props.theme.pink_100;
    } else {
        return props.theme.grey_72_lc;
    }
};
const getBorderColor = (props) => {
    if (!props.isFocused && !props.isError && !props.isLinedInput) {
        return props.theme.grey_28_tr;
    } else if (!props.isFocused && !props.isError) {
        return props.theme.grey_40_lc;
    } else if (props.isFocused && !props.isError) {
        return props.theme.purple_100;
    } else if (props.isError) {
        return props.theme.pink_100;
    } else {
        return props.theme.grey_72_lc;
    }
};

const getFloatingLabelPosition = (props) => {
    if (props.isLinedInput) {
        return props.isFilled || props.isFocused ? '-4px' : '24px';
    } else {
        return props.isFilled || props.isFocused ? '-12px' : '16px';
    }
};
const getFloatingLabelDesktopPosition = (props) => {
    if (props.isLinedInput) {
        return props.isFilled || props.isFocused ? '-8px' : '28px';
    } else {
        return props.isFilled || props.isFocused ? '-14px' : '20px';
    }
};
const getFloatingLabelLeftPosition = (props) => {
    if (props.isLinedInput) {
        return '0';
    } else if (props.isCaptcha) {
        return 'calc(50% - 8px)';
    } else {
        return '8px';
    }
};
const getFloatingLabelLeftDesktopPosition = (props) => {
    if (props.isLinedInput) {
        return '0';
    } else if (props.isCaptcha) {
        return 'calc(50% - 8px)';
    } else {
        return '16px';
    }
};

export const InputContainer = styled.div`
    font-family: ${fonts.regular};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    position: relative;
    border: ${(props) => (props.isLinedInput || props.isCalculatorInput ? null : `1px ${props.isReadOnly ? `dashed` : `solid`} ${props.theme.grey_28_tr}`)};
    border-bottom: ${(props) => (props.isCalculatorInput ? null : `1px ${props.isReadOnly ? `dashed` : `solid`} ${getBorderColor(props)}`)};
    border-radius: ${(props) => (props.isLinedInput ? null : '6px')};
    pointer-events: ${(props) => (props.isReadOnly ? 'none' : null)};

    &:after {
        display: ${(props) => (props.isCalculatorInput ? 'none' : null)};
        content: '';
        position: absolute;
        width: ${(props) => (props.isLinedInput ? '100%' : 'calc(100% - 4px)')};
        height: 1px;
        background: ${(props) => (!props.isFocused && !props.isError ? null : getBorderColor(props))};
        bottom: 0;
        left: ${(props) => (props.isLinedInput ? '0' : '2px')};

        ${media.desktop1920} {
            height: 2px;
        }
    }
`;

export const InputLabel = styled.label`
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    padding: ${(props) => (props.isLinedInput ? '0 0 6px 0' : props.isCalculatorInput ? '12px 0' : '16px')};
    cursor: ${(props) => (props.isPseudoSelect ? 'pointer' : null)};
    z-index: 1;

    ${media.desktop1920} {
        padding: ${(props) => (props.isLinedInput ? '0 0 12px 0' : '20px 24px')};
    }

    input,
    input[type='search'],
    textarea {
        font-family: ${(props) => (props.isSmsInput ? 'Courier New,monospace' : fonts.regular)};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        background-color: transparent;
        color: ${(props) => (props.isCalculatorInput && props.isError ? props.theme.pink_100 : props.isReadOnly ? props.theme.grey_40_lc : props.theme.black)};
        border: none;
        box-sizing: border-box;
        display: inline-block;
        padding: ${(props) => (props.isLinedInput ? '24px 0 0 0' : props.isPseudoSelect ? '0 24px 0 0' : '0')};
        width: 100%;
        font-size: ${(props) => (props.isCalculatorInput ? '40px' : '17px')};
        line-height: ${(props) => (props.isCalculatorInput ? '48px' : '24px')};
        text-overflow: ${(props) => (props.isCalculatorInput ? null : 'ellipsis')};
        cursor: auto;
        text-align: ${(props) => (props.isSmsInput || props.isCenteredInput || props.isCalculatorInput ? 'center' : null)};
        font-weight: ${(props) => (props.isSmsInput ? '700' : null)};
        letter-spacing: ${(props) => (props.isSmsInput ? '16px' : null)};
        outline: none;

        &:hover {
            color: ${(props) => (props.isCalculatorInput && props.isError ? props.theme.pink_100 : props.isCalculatorInput ? props.theme.purple_100 : null)};
        }

        &:-webkit-autofill {
            -webkit-box-shadow: ${(props) => `inset 0 0 0 50px ${props.theme.white}`};
            -webkit-text-fill-color: ${(props) => props.theme.black};
            color: ${(props) => props.theme.black} !important;
        }

        ${media.desktop1920} {
            padding: ${(props) => (props.isLinedInput ? '28px 0 0 0' : props.isPseudoSelect ? '0 28px 0 0' : '0')};
            font-size: ${(props) => (props.isCalculatorInput ? '48px' : '20px')};
            line-height: ${(props) => (props.isCalculatorInput ? '64px' : '32px')};
            letter-spacing: ${(props) => (props.isSmsInput ? '18px' : null)};
        }
    }

    /* custom phone library styling */
    .react-tel-input {
        width: 100%;

        .flag-dropdown {
            display: none;
        }
    }
`;

export const FloatingLabel = styled.span`
    position: absolute;
    top: ${(props) => getFloatingLabelPosition(props)};
    left: ${(props) => getFloatingLabelLeftPosition(props)};
    font-size: ${(props) => (props.isFilled || props.isFocused ? '14px' : '17px')};
    line-height: ${(props) => (props.isFilled || props.isFocused ? '20px' : '24px')};
    color: ${(props) => getLabelColor(props)};
    transition: top 0.2s;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: calc(100% - 16px);
    box-sizing: border-box;
    padding: ${(props) => (props.isLinedInput ? null : '0 8px')};
    background: ${(props) => (props.isLinedInput ? null : props.theme.white)};
    width: ${(props) => (props.isCenteredInput ? 'calc(100% - 32px)' : null)};
    text-align: ${(props) => (props.isCenteredInput ? 'center' : null)};
    display: ${(props) => (props.isCenteredInput && (props.isFocused || props.isFilled) ? 'none' : null)};

    ${media.desktop1920} {
        top: ${(props) => getFloatingLabelDesktopPosition(props)};
        left: ${(props) => getFloatingLabelLeftDesktopPosition(props)};
        font-size: ${(props) => (props.isFilled || props.isFocused ? '17px' : '20px')};
        line-height: ${(props) => (props.isFilled || props.isFocused ? '24px' : '32px')};
    }
`;

export const DiskButtonContainer = styled.span`
    margin-left: 4px;
`;

export const HintContainer = styled.div`
    margin-top: 8px;
    padding: ${(props) => (props.isLinedInput ? null : '0 16px')};
    text-align: left;
    display: flex;

    ${media.desktop1920} {
        padding: ${(props) => (props.isLinedInput ? null : '0 24px')};
    }
`;

export const HintButton = styled.span`
    margin-top: -4px;
    margin-left: 2px;
`;

export const InputRightElement = styled.div`
    position: absolute;
    right: ${(props) => (props.isInfoButtonForPseudoselect ? '46px' : '16px')};
    top: ${(props) => (props.isInfoButton ? '14px' : '16px')};
    z-index: ${(props) => (props.isInfoButton ? '1' : null)};

    ${media.desktop1920} {
        right: ${(props) => (props.isInfoButtonForPseudoselect ? '54px' : '16px')};
        top: ${(props) => (props.isInfoButton ? '18px' : '24px')};
    }
`;

/* promo part */
export const PromoHintContainer = styled.div`
    padding: 8px 16px;

    ${media.desktop1920} {
        padding: 8px 24px;
    }
`;
